import { useRef, useState } from 'react';
import Swiper from 'swiper';

export const usePacketsSlider = () => {
	const sliderRef = useRef<Swiper>();
	const [isLastSlide, setIsLastSlide] = useState(false);

	const onBeforeInit = (swiper: Swiper) => {
		sliderRef.current = swiper;
	};

	const onSlideChange = (swiper: Swiper) => {
		setIsLastSlide(swiper.isEnd);
	};

	return { onBeforeInit, onSlideChange, isLastSlide };
};
